import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { OptionsService } from '../services/options.service'
import { setInsertionSiteOptions } from '../store/options.actions'

export function* getInsertionSiteOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const insertionSiteOptionsResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getInsertionSiteOptions,
    ])
    const { entity } = insertionSiteOptionsResponse
    if (entity) yield put(setInsertionSiteOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getInsertionSiteOptions() error: ${e}`))
  }
}

export function* getInsertionSiteOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getInsertionSiteOptions)
}
